export default __webpack_public_path__ + "static/media/loadingGIF.83785d71.gif";